import { createSelector } from '@reduxjs/toolkit';
import { getOrganization } from '../organization/getOrganization';
import type { FunctionViewModel } from '@trinnvis/dabih-api-client';

import { toList } from '../toList';

export const functionsNotDeleted = createSelector(getOrganization, (organization): FunctionViewModel[] => {
  if (organization === undefined) {
    return [];
  }
  return toList(organization.functionsById).filter((e) => !e.deleted);
});
